import Config from 'config';
import LogRocket from 'logrocket';

if (Config.env == 'production') {
  LogRocket.init('bfrb0y/tramitar');
}
